import { makeStyles } from '@mui/styles';
import { neptunePrimaryDark } from 'apollo-react/colors';
import Typography from 'apollo-react/components/Typography';
import Route from 'apollo-react-icons/Route';
import React from 'react';

import { useTranslation } from '../custom-hooks/useTranslation';

const useStyles = makeStyles({
  errorContainer: {
    textAlign: 'center',
    marginTop: '50px',
    color: neptunePrimaryDark,
  },
  errorMessage: {
    color: neptunePrimaryDark,
  },
});

const EditorErrorPage = () => {
  const classes = useStyles();

  const translateString = useTranslation();
  const errorMessage = translateString('Page cannot be loaded');

  return (
    <div className={classes.errorContainer}>
      <Route fontSize="large" />
      <Typography variant="title2" className={classes.errorMessage}>
        {errorMessage}
      </Typography>
    </div>
  );
};

export default EditorErrorPage;
